<template>
  <picture :class="customClass" :style="customStyle">
    <!-- WebP 源（如果提供了 webpUrl） -->
    <source v-if="webpUrl" :srcset="webpUrl" type="image/webp" />
    <!-- 主图（PNG 或默认图） -->
    <img
      :src="pngUrl || defaultImage"
      :alt="altText"
      @error="handleImageError"
    />
  </picture>
</template>

<script>
export default {
  name: "SmartImage",
  props: {
    webpUrl: {
      type: String,
      default: "",
    },
    pngUrl: {
      type: String,
      default: "",
    },
    altText: {
      type: String,
      required: true,
    },
    // 注意：class 现在应用到 <picture> 标签
    customClass: {
      type: [String, Array, Object],
      default: "",
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
    defaultImage: {
      type: String,
      default:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2VlZSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjYWFhIj5JbWFnZSBub3QgZm91bmQ8L3RleHQ+PC9zdmc+",
    },
  },
  methods: {
    handleImageError(e) {
      if (this.defaultImage && e.target.src !== this.defaultImage) {
        e.target.src = this.defaultImage;
      }
    },
  },
};
</script>

<style scoped>
/* 可选：确保 <picture> 和 <img> 的样式继承关系 */
picture {
  display: inline-block; /* 避免默认行内元素特性 */
  line-height: 0; /* 消除图片底部间隙 */
}
picture img {
  max-width: 100%;
  height: auto;
}
</style>
